import {CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import {FooterComponent} from './footer/footer.component';
import {NavbarComponent} from './navbar/navbar.component';
import {SidebarComponent} from './sidebar/sidebar.component';
import {ToggleFullscreenDirective} from './directives/toggle-fullscreen.directive';
import {CustomValidators} from './custom-validators/custom-validators';
import {UtilsService} from './utils/utils.service';
import {InputCustomComponent} from '../component/input-custom/input-custom.component';
import {DateCustomComponent} from '../component/date-custom/date-custom.component';
import {SelectAutocompleteCustomComponent} from '../component/select-autocomplete-custom/select-autocomplete-custom.component';
import {SelectCustomComponent} from '../component/select-custom/select-custom.component';
import {TagsCustomComponent} from '../component/tags-custom/tags-custom.component';
import {TagInputModule} from 'ngx-chips';
import {DisciplineService} from './services/discipline.service';
import {DocumentService} from './services/document.service';
import {ModalGenericComponent} from './modal-generic/modal-generic.component';
import {ModalGenericService} from './modal-generic/modal-generic.service';
import {AlertErrorComponent} from './alert/alert-error.component';
import {JhiAlertService, JhiEventManager, NgJhipsterModule} from 'ng-jhipster';
import {AlertService} from './alert/alert.service';
import {CercaTesseratoComponent} from '../servizi/tesseramento/cerca-tesserato/cerca-tesserato.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CreaTesseramentoDirigenteComponent} from '../servizi/tesseramento/crea-tesseramento/dirigente/crea-tesseramento-dirigente.component';
import {AnomaliesPopoverComponent} from './ag-grid-custom-components/anomalies-popover/popover.components';
import {SubscriberTitlesPopoverComponent} from './ag-grid-custom-components/subscriber-titles-popover/popover.components';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {GeneraTesserinoComponent} from './genera-tesserino/genera-tesserino.component';
import {AgGridStateManagerService} from './services/agGridStateManager.service';
import {PrivacyModalComponent} from './privacy-modal/privacy-modal.component';
import {UtentiService} from '../utenti/utenti.service';
import {AccountService} from './auth/account.service';
import {PassaggioModalComponent} from "./passaggio-modal/passaggio-modal.component";
import {RitiraTessereComponent} from "../servizi/tessere/ritira-tessere/ritira.component";
import {AssegnaTessereComponent} from "../servizi/tessere/assegna-tessere/assegna.component";
import {TessereService} from "../servizi/tessere/tessere.service";
import {CreaGaraComponent} from "../servizi/gare/crea/crea.component";
import {GareService} from "../servizi/gare/gare.service";
import {TesseramentoService} from "../servizi/tesseramento/tesseramento.service";
import {UiSwitchModule} from "ngx-ui-switch";
import {CercaTesseratoMultyComponent} from "../servizi/tesseramento/cerca-tesserato-multy/cerca-tesserato-multy.component";
import {NotificheService} from "../notifiche/notifiche.service";
import {GalleriaComponent} from "../servizi/formativa/galleria/galleria.component";
import {ImageRenderer} from "./ag-grid-custom-components/image-renderer";
import {StatePopoverComponent} from './ag-grid-custom-components/state-popover/popover.components';
import {PaypalButtonComponent} from './paypalButton/paypal-button.component';
import {PaymentSuccessService} from './paypalButton/payment-success.service';
import {PaymentFailureService} from './paypalButton/payment-failure.service';
import {ModalGenericNoteComponent} from './modal-generic-note/modal-generic-note.component';
import {ModalGenericNote} from './modal-generic-note/modal-generic-note.service';


@NgModule({
  exports: [
    CommonModule,
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    ToggleFullscreenDirective,
    NgbModule,
    InputCustomComponent,
    DateCustomComponent,
    SelectAutocompleteCustomComponent,
    SelectCustomComponent,
    TagInputModule,
    TagsCustomComponent,
    NgJhipsterModule,
    AlertErrorComponent,
    CreaGaraComponent,
    CercaTesseratoComponent,
    CercaTesseratoMultyComponent,
    GalleriaComponent,
    ImageRenderer,
    PaypalButtonComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CommonModule,
    NgbModule.forRoot(),
    TagInputModule,
    UiSwitchModule,
    NgJhipsterModule.forRoot({
      // set below to true to make alerts look like toast
      alertAsToast: true,
    }),
    PopoverModule.forRoot(),
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    RitiraTessereComponent,
    AssegnaTessereComponent,
    CreaGaraComponent,
    CercaTesseratoComponent,
    CercaTesseratoMultyComponent,
    CreaTesseramentoDirigenteComponent,
    ToggleFullscreenDirective,
    InputCustomComponent,
    DateCustomComponent,
    SelectAutocompleteCustomComponent,
    SelectCustomComponent,
    TagsCustomComponent,
    ModalGenericComponent,
    PrivacyModalComponent,
    PassaggioModalComponent,
    AlertErrorComponent,
    AnomaliesPopoverComponent,
    GeneraTesserinoComponent,
    SubscriberTitlesPopoverComponent,
    StatePopoverComponent,
    GalleriaComponent,
    ImageRenderer,
    PaypalButtonComponent,
    ModalGenericNoteComponent
  ],
  providers: [
    CustomValidators,
    UtilsService,
    AccountService,
    DocumentService,
    DisciplineService,
    AgGridStateManagerService,
    AlertService,
    ModalGenericService,
    ModalGenericNote,
    TessereService,
    TesseramentoService,
    GareService,
    NotificheService,
    JhiEventManager,
    PaymentSuccessService,
    PaymentFailureService
  ],
  entryComponents: [
    ModalGenericComponent,
    ModalGenericNoteComponent,
    PrivacyModalComponent,
    PassaggioModalComponent,
    GalleriaComponent,
    StatePopoverComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class SharedModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts